
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-insights",
      function () {
        return require("private-next-pages/data-insights.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-insights"])
      });
    }
  